import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import { useTheme } from 'styled-components';
import { TextBoxProps } from 'src/types';

export const WhiteTextBox = (props: TextBoxProps) => {
  const theme = useTheme();
  const classes =
    props.classes && typeof props.classes === 'object'
      ? props.classes
      : undefined;
  const whiteClassName =
    typeof props.classes === 'string' ? props.classes : classes?.white;
  return (
    <FormControl style={Object.assign({ minWidth: '100%' }, props.style)}>
      <InputLabel
        data-testid={props['data-testid']}
        htmlFor="adornment-password"
        className={whiteClassName}
        classes={
          classes?.focussed
            ? {
                focused: classes.focussed,
                formControl: classes.focussed,
              }
            : undefined
        }
        style={{
          color: theme.isVaultVariant
            ? theme.newPalette.neutral.N0
            : theme.atlas.semantic.color.type.inverse,
          borderBottom: 'none',
        }}
      >
        {props.placeholder}
      </InputLabel>
      <Input
        autoComplete={props.autoComplete}
        className={whiteClassName}
        classes={
          classes
            ? {
                focused: classes.focussed,
                underline: classes.underline,
              }
            : undefined
        }
        id={props.id}
        type={'text'}
        value={props.value}
        onChange={props.onChange}
        onKeyPress={(e) => {
          if (props.enterKeyAction && e.charCode === 13) {
            e.preventDefault();
            props.enterKeyAction();
          }
        }}
        data-testid="whitetextbox-input"
      />
    </FormControl>
  );
};
